<div class="cardLayout">
  <div class="font_semibold fs-14 fs_12ForMobile mb-10" *ngIf="showExtendedDueDate">Extension {{extensionNumber}}</div>
  <mat-form-field class="w-100 mw-sm-250 mat-input-style mat-height40 mr-15" *ngIf="showExtendedDueDate">
    <input readonly matInput [matDatepicker]="startDate" [(ngModel)]="setExtendedDueDate"
      [ngModelOptions]="{standalone: true}" placeholder="DD/MM/YYYY" [min]="minDate">
    <mat-datepicker-toggle matIconSuffix [for]="startDate"></mat-datepicker-toggle>
    <mat-datepicker #startDate></mat-datepicker>
  </mat-form-field>
  
  <div *ngIf="showComment" class="font_semibold fs-14 fs_12ForMobile mb-10">Comment</div>
  <textarea style="resize: none;" maxlength="255" (ngModelChange)="checkLengthOfField(skipComment)" class="w-100 mat-input-style mat-height40" placeholder="Type here....." rows="8" cols="20" *ngIf="showComment" [(ngModel)]="skipComment"></textarea>
  <label *ngIf="isSubmitBtnClicked && skipComment==''" class="fs-12 font_regular red-cl">Comment is required</label>
  <ion-row class="p-0 mt-20">
    <ion-col class="d-flex">
      <button *ngIf="button1" class="font_medium back_btn mr-30 mr-10ForMobileView" (click)="btn1Action()">{{button1}}</button>
      <button *ngIf="button2" class="font_medium add_btn" [ngStyle]="{'background-color': color}" (click)="btn2Action()" [disabled]="showExtendedDueDate && !setExtendedDueDate || isBtn2Disabled">{{button2}}</button>
    </ion-col>
  </ion-row>
</div>